import { render } from "./FormularioDatos.vue?vue&type=template&id=7548caa6&scoped=true"
import script from "./FormularioDatos.vue?vue&type=script&lang=js"
export * from "./FormularioDatos.vue?vue&type=script&lang=js"

import "./FormularioDatos.vue?vue&type=style&index=0&id=7548caa6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7548caa6"]])

export default __exports__